import { TransactionFragment } from "@/__generated__/graphql";
import { DataViewThreadActions } from "@/components/organisms/DataView/DataViewThreadActions";
import { type TableDialogSelectionActionsProps } from "@/components/organisms/Table/TableDialog";
import { ThreadMessageContextItemType } from "@/state/@types";

export function transactionToThreadContext(
  transaction: TransactionFragment,
): ThreadMessageContextItemType {
  return {
    id: transaction.id,
    identifier: transaction.identifier,
    name: transaction.description || "Untitled",
    typename: "TransactionObject",
  };
}

export const TRANSACTION_THREAD_MENU_OPTIONS = [
  { id: "reconcile", message: "Reconcile" },
  { id: "matching-documents", message: "Find matching documents" },
  { id: "shareholder-loan", message: "Mark as shareholder loan" },
] as const;

type TransactionsViewThreadActionsProps = TableDialogSelectionActionsProps & {
  onPrepareThread: (checkedRowIds: string[], draft?: string) => void;
};

export function TransactionsViewThreadActions({
  menuOptions = TRANSACTION_THREAD_MENU_OPTIONS,
  ...props
}: TransactionsViewThreadActionsProps & {
  menuOptions?: typeof TRANSACTION_THREAD_MENU_OPTIONS;
}) {
  return <DataViewThreadActions {...props} menuOptions={[...menuOptions]} />;
}
